export const QUERY_KEYS = {
  GET_VERSIONS: 'getVersions',
};
